/*
 * @Description: 备案合同待办接口
 * @Date: 2026-09-18
 */
import service from '@/utils/request'

// 备案合同待办列表
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractJob/page',
    data: params
  })

// 重置待办
export const resetTodo = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractJob/reset',
    data: params
  })

// 删除待办
export const deleteTodo = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractJob/delete',
    data: params
  })

// 企业名称（下拉）
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })
